
import React, { useState, useEffect } from "react";
import store from "./app/redux/store";
import * as Actions from "./app/redux/actions";
import { useSelector } from "react-redux";
import { Provider } from "react-redux";

import Catalog from "./router";
import LoginRouter from "../login/router";
import Loading from "./app/components/common/loading";


const App = () => {
  const [loading, setLoading] = useState(true);
  const { logged } = useSelector((state) => state.login);

  useEffect(() => {
    
    store
      .dispatch(Actions.checkToken())
      .then((responseAction) => {
        setLoading(false);

        if (responseAction.type === Actions.USER_LOGED) {
          store.dispatch(Actions.confirmAuth({status:true, data:responseAction.payload.data}));
        }
      })
      .catch((error) => {
        console.log("ERROR!! no token ....");
      });
  }, []);

  return (
    <Provider store={store}>

      {loading && <Loading/>}
      {!loading && logged && <Catalog />}
      {!loading && !logged && <LoginRouter />}

    </Provider>
  );
};

export default App;
